import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import { c as classNames } from '../../shared/bind-56cf2a3b.js';
import { s as styles, T as Tab, a as TabTitle } from '../../shared/Tab-e695f23d.js';
import Divider from '../Divider/Divider.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var Width = /*#__PURE__*/function (Width) {
  Width["Parent"] = "parent";
  return Width;
}(Width || {});
var Styling = /*#__PURE__*/function (Styling) {
  Styling["Wide"] = "wide";
  return Styling;
}(Styling || {});
var cssClasses = classNames.bind(styles);
var Tabs = function Tabs(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'tablist' : _ref$role,
    activeItemId = _ref.activeItemId,
    width = _ref.width,
    styling = _ref.styling,
    onClick = _ref.onClick,
    testId = _ref.testId,
    divider = _ref.divider;
  var tabsClasses = cssClasses('tabs', width, styling);
  var getTabTestId = function getTabTestId(id) {
    if (testId) {
      var _context, _context2;
      return activeItemId === id ? _concatInstanceProperty(_context = "".concat(testId, "-")).call(_context, id, "--active") : _concatInstanceProperty(_context2 = "".concat(testId, "-")).call(_context2, id);
    }
    return undefined;
  };
  var tabItems = _mapInstanceProperty(items).call(items, function (item) {
    return /*#__PURE__*/jsx(Tab, {
      item: item,
      role: role === 'tablist' ? 'tab' : 'menuitem',
      onClick: onClick,
      isActive: activeItemId === item.id,
      testId: getTabTestId(item.id)
    }, item.id);
  });
  return /*#__PURE__*/jsxs("div", {
    className: tabsClasses,
    "data-testid": testId,
    children: [/*#__PURE__*/jsx("ul", {
      className: styles.content,
      role: role,
      children: tabItems
    }), divider ? /*#__PURE__*/jsx(Divider, {
      className: styles.divider
    }) : null]
  });
};
Tabs.Width = Width;
Tabs.Styling = Styling;
Tabs.TabTitle = TabTitle;

export { Tabs as default };
//# sourceMappingURL=Tabs.js.map
